// extracted by mini-css-extract-plugin
module.exports = {"content":"content-module--content--1Dytx"};